/**
 * C - Main Product Static V2
 * Self-contained Alpine controller. Same data-island pattern as v1,
 * with awareness of the new variant fields (is_popular, features,
 * plan_description, guide_label, guide_included, price_suffix).
 */
(function () {
  function parseProductsFromRoot(rootEl) {
    if (!rootEl) return [];
    var raw = rootEl.getAttribute('data-products') || '[]';
    try {
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed
        .filter(function (p) { return p && p.variants && p.variants.length; })
        .map(autoPopular);
    } catch (e) {
      console.warn('[c-main-product-static-v2] Failed to parse products JSON', e);
      return [];
    }
  }

  /**
   * Popular-badge resolution, in order of priority:
   *   1) explicit override (popular_variant_index from schema setting)
   *   2) variant flagged via `smart.is_popular` metafield
   *   3) available variant with highest save_percentage
   */
  function autoPopular(product) {
    var variants = product.variants || [];

    var overrideIdx = parseInt(product.popular_variant_index, 10);
    if (!isNaN(overrideIdx) && overrideIdx >= 0 && overrideIdx < variants.length) {
      for (var k = 0; k < variants.length; k++) {
        variants[k].is_popular = (k === overrideIdx);
      }
      return product;
    }

    var anyExplicit = variants.some(function (v) { return v.is_popular === true; });
    if (anyExplicit) return product;
    var bestIdx = -1;
    var bestSave = 0;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.available && v.save_percentage > bestSave) {
        bestSave = v.save_percentage;
        bestIdx = i;
      }
    }
    if (bestIdx >= 0) variants[bestIdx].is_popular = true;
    return product;
  }

  function formatMoneyCents(cents) {
    if (typeof cents !== 'number') cents = parseInt(cents, 10) || 0;
    try {
      if (window.utils && typeof window.utils.formatMoney === 'function') {
        var formatted = window.utils.formatMoney(cents);
        if (typeof formatted === 'string') {
          return formatted.replace(/<[^>]*>/g, '').trim();
        }
      }
    } catch (e) { /* fall through */ }
    var amount = (cents / 100).toFixed(2);
    return '$' + amount;
  }

  /**
   * Initial variant selection, in order of priority:
   *  1) explicit override (default_variant_index from schema setting)
   *  2) variant marked `is_popular`
   *  3) available variant with the highest save_percentage
   *  4) else 0
   */
  function pickInitialVariantIndex(product) {
    var variants = Array.isArray(product) ? product : (product && product.variants) || [];
    if (!variants.length) return 0;

    if (!Array.isArray(product)) {
      var overrideIdx = parseInt(product.default_variant_index, 10);
      if (!isNaN(overrideIdx) && overrideIdx >= 0 && overrideIdx < variants.length) {
        return overrideIdx;
      }
    }

    for (var i = 0; i < variants.length; i++) {
      if (variants[i].is_popular && variants[i].available) return i;
    }
    var bestIdx = 0;
    var bestSave = -1;
    for (var j = 0; j < variants.length; j++) {
      var v = variants[j];
      if (v.available && v.save_percentage > bestSave) {
        bestSave = v.save_percentage;
        bestIdx = j;
      }
    }
    return bestIdx;
  }

  function registerAlpine() {
    if (!window.Alpine || typeof window.Alpine.data !== 'function') return;
    if (window.Alpine.__cMainProductStaticV2Registered) return;
    window.Alpine.__cMainProductStaticV2Registered = true;

    window.Alpine.data('cMainProductStaticV2', function (rootEl) {
      var products = parseProductsFromRoot(rootEl);
      var initialVariantIdx = products.length
        ? pickInitialVariantIndex(products[0])
        : 0;

      return {
        sectionId: rootEl ? (rootEl.getAttribute('data-section-id') || '') : '',
        redirectToCheckout: rootEl
          ? rootEl.getAttribute('data-redirect-checkout') === 'true'
          : false,
        products: products,
        activeProductIndex: 0,
        activeVariantIndex: initialVariantIdx,
        isAdding: false,
        get activeProduct() {
          return this.products[this.activeProductIndex] || null;
        },
        get activeVariant() {
          var p = this.products[this.activeProductIndex];
          if (!p || !p.variants) return null;
          return p.variants[this.activeVariantIndex] || null;
        },
        setActiveProduct: function (idx) {
          if (idx < 0 || idx >= this.products.length) return;
          this.activeProductIndex = idx;
          this.activeVariantIndex = pickInitialVariantIndex(this.products[idx]);
        },
        setActiveVariant: function (idx) {
          var variants = (this.activeProduct && this.activeProduct.variants) || [];
          if (idx < 0 || idx >= variants.length) return;
          this.activeVariantIndex = idx;
        },
        formatMoney: function (cents) {
          return formatMoneyCents(cents);
        },
        addToCart: function (e) {
          if (e && e.preventDefault) { e.preventDefault(); e.stopPropagation(); }
          var variant = this.activeVariant;
          if (!variant || !variant.available || this.isAdding) return;

          var self = this;
          self.isAdding = true;

          var item = { id: variant.id, quantity: 1 };
          if (variant.selling_plan_id) item.selling_plan = variant.selling_plan_id;

          var redirect = self.redirectToCheckout;
          var sectionRoot = document.getElementById('c-main-product-static-v2-' + self.sectionId);
          if (sectionRoot) {
            var ctaWrap = sectionRoot.querySelector('[data-redirect-checkout="true"]');
            if (ctaWrap) redirect = true;
          }

          var finish = function (ok) {
            self.isAdding = false;
            if (!ok) return;
            if (redirect) {
              window.location.href = '/checkout';
              return;
            }
            try {
              if (window._stores && window._stores.modal && typeof window._stores.modal.setId === 'function') {
                window._stores.modal.setId('modal--cart-drawer');
              }
            } catch (err) { /* noop */ }
          };

          if (window._cart && typeof window._cart.add === 'function') {
            Promise.resolve(window._cart.add({ items: [item] }))
              .then(function (res) { finish(!(res && res.cart_error)); })
              .catch(function () { finish(false); });
            return;
          }

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [item] })
          })
            .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
            .then(function () { finish(true); })
            .catch(function () { finish(false); });
        }
      };
    });
  }

  if (window.Alpine) {
    registerAlpine();
  } else {
    document.addEventListener('alpine:init', registerAlpine);
  }
})();
